import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PhotosView from '../views/PhotosView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import UploadView from '../views/UploadView.vue'
import PhotoDetailView from '../views/PhotoDetailView.vue'
import MyPhotosView from '@/views/MyPhotosView.vue'
import MyFavoritesView from '@/views/MyFavoritesView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import DesignView from '@/views/DesignView.vue'
import ModelViewerView from '@/views/ModelViewerView.vue'
import AICreationView from '@/views/AICreationView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/ai-creation',
    name: 'AICreation',
    component: AICreationView
  },
  {
    path: '/photos',
    name: 'photos',
    component: PhotosView
  },
  {
    path: '/design',
    name: 'design',
    component: DesignView
  },
  {
    path: '/photos/:id',
    name: 'photo-detail',
    component: PhotoDetailView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/upload',
    name: 'upload',
    component: UploadView
  },
  {
    path: '/my/photos',
    name: 'MyPhotos',
    component: MyPhotosView,
    meta: { requiresAuth: true }
  },
  {
    path: '/my/favorites',
    name: 'MyFavorites',
    component: MyFavoritesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/design',
    name: 'Design',
    component: () => import('@/views/DesignView.vue')
  },
  {
    path: '/membership',
    name: 'Membership',
    component: () => import('../views/MembershipView.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordView
  },
  {
    path: '/models',
    name: 'ModelViewer',
    component: ModelViewerView
  },
]

const router = new VueRouter({
  routes
})

export default router
